import BrandLogo from "/static/images/tenants/keychron/keychron_white.svg";
import { keychronContent } from "../brandContent/keychronBrandContent";
import { keychronPrize } from "../brandPrize/keychronPrize";
import { keychron } from "../brandThemes/keychron";

// Same brand data as the Keychron CS2 board (tenant, prize, theme, gameType)
// but a dedicated gameStyle so the time-trail layout can be styled in isolation
// without affecting the existing /keychron-tt board.
export const KEYCHRONTIMETRAIL_brandVariables = {
  tenantId: "keychron-kzk8f",
  themeId: "keychron",
  gameStyle: "timetrail",
  eventCode: "",
  gameType: "CSGO",
  brandLogoType: "element",
  brandLogo: BrandLogo,
  brandLogoSize: 400,
  theme: keychron,
  content: keychronContent,
  prize: keychronPrize,

  leaderboardLength: 10,
  disclaimer: "Set the fastest time and win a",
};
